import {
	createContext,
	useContext,
	type Dispatch,
	type SetStateAction,
} from 'react';
import { AcceptDispatchOkI } from 'modules/creditCard';
import { DialogMakePaymentStep } from './titles';

export interface DialogMakePaymentContextValue {
	formErrors: {
		amount: string;
		payFullBalance: string;
		cardCode: string;
		cardNumber: string;
		expirationDate: string;
	};
	formValues: {
		amount: string;
		payFullBalance: boolean;
		cardCode: string;
		cardNumber: string;
		expirationDate: string;
	};
	opaqueData: AcceptDispatchOkI['opaqueData'] | null;
	step: DialogMakePaymentStep;
	clearSensitiveFormValues: () => void;
	onSubmitSuccess: () => void;
	onSubmitError: () => void;
	setFormErrors: Dispatch<
		SetStateAction<{
			amount: string;
			payFullBalance: string;
			cardCode: string;
			cardNumber: string;
			expirationDate: string;
		}>
	>;
	setFormValues: Dispatch<
		SetStateAction<{
			amount: string;
			payFullBalance: boolean;
			cardCode: string;
			cardNumber: string;
			expirationDate: string;
		}>
	>;
	setOpaqueData: Dispatch<
		SetStateAction<AcceptDispatchOkI['opaqueData'] | null>
	>;
	setStep: (newStep: DialogMakePaymentStep) => void;
}

const dialogMakePaymentContext = createContext<DialogMakePaymentContextValue>(
	null!,
);

export const useDialogMakePaymentContext = () =>
	useContext(dialogMakePaymentContext);

export default dialogMakePaymentContext;
